module.exports = __webpack_public_path__ + "img/pharmeleon.3fff5c81.png";